// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapPreview-module__answerS3FileViewer__eTXK6 {
  display: flex;
  align-items: center;
  width: 100%;
}
.MapPreview-module__answerS3FileViewerText__JaYIC {
  cursor: pointer;
  color: #07a6f3;
  max-width: 300px;
  padding-right: 3px;
}
.MapPreview-module__answerS3FileViewerText__JaYIC:hover {
  color: #26bbf0;
}
.MapPreview-module__s3FactTableContainer__C67lZ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.MapPreview-module__s3FactTableButtonContainer__i47Gp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}
.MapPreview-module__tableFactTableContainer__vWczr {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.MapPreview-module__fileButton__xstUH {
  height: 32px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  background: #f0f0f0;
  display: flex;
  padding: 5px 12px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  color: rgba(0, 0, 0, 0.85);
}
.MapPreview-module__fileButton__xstUH:hover {
  border: 1px solid #b37feb;
  background: #efdbff;
}
.MapPreview-module__filePreviewContainer__JocNr {
  padding: 30px 6px 0 6px;
  width: 100%;
}
.MapPreview-module__filePreviewHeader__OLSmn {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}
.MapPreview-module__expandContainer__FJvAE {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.MapPreview-module__downloadButton__ysNq4 {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  margin-right: 12px;
}
.MapPreview-module__title__Srqxk {
  display: flex;
  align-items: center;
}
.MapPreview-module__previewIcons__g64OY {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.MapPreview-module__mapContainer__ITd15 {
  position: relative;
  height: 75vh;
  width: 100%;
}
.MapPreview-module__legend__nE_qW {
  position: absolute;
  bottom: 30px;
  left: 15px;
  background: rgba(22, 19, 19, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  z-index: 1;
  min-width: 200px;
  border-radius: 5px;
  padding: 10px 20px;
}
.MapPreview-module__legend__nE_qW .MapPreview-module__timeRange__egyqT {
  color: #fff;
  font-weight: 500;
}
.MapPreview-module__legend__nE_qW .MapPreview-module__divider__XvIYa {
  width: 100%;
  height: 2px;
  background: #fff;
  margin: 10px 0;
}
.MapPreview-module__legend__nE_qW .MapPreview-module__legendItem__WtxWv {
  display: flex;
  align-items: center;
  margin: 5px 0;
  color: #fff;
  font-weight: 500;
}
.MapPreview-module__legend__nE_qW .MapPreview-module__legendItem__WtxWv .MapPreview-module__legendColor__kuNHO {
  border: 2px solid #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.MapPreview-module__legendTextCheck__OerQO {
  color: #fff;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/MapPreview/MapPreview.module.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AADF;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AALF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AANF;AASA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;AAPF;AAUA;EACE,yBAAA;EACA,mBAAA;AARF;AAWA;EACE,uBAAA;EACA,WAAA;AATF;AAYA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAVF;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXF;AAcA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAdF;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAfF;AAkBA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAhBF;AAGA;EAgBI,WAAA;EACA,gBAAA;AAhBJ;AADA;EAqBI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAjBJ;AAPA;EA4BI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAlBJ;AAdA;EAmCM,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAlBN;AAuBA;EACE,WAAA;EACA,gBAAA;AArBF","sourcesContent":["@import '@css/variables.less';\n\n.answerS3FileViewer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.answerS3FileViewerText {\n  cursor: pointer;\n  color: @color-link-blue;\n  max-width: 300px;\n  padding-right: 3px;\n\n  &:hover {\n    color: @color-link-blue-hover;\n  }\n}\n\n.s3FactTableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.s3FactTableButtonContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.tableFactTableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.fileButton {\n  height: 32px;\n  border-radius: 2px;\n  border: 1px solid #d9d9d9;\n  background: #f0f0f0;\n  display: flex;\n  padding: 5px 12px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.fileButton:hover {\n  border: 1px solid #b37feb;\n  background: #efdbff;\n}\n\n.filePreviewContainer {\n  padding: 30px 6px 0 6px;\n  width: 100%;\n}\n\n.filePreviewHeader {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px;\n}\n\n.expandContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.downloadButton {\n  color: rgba(0, 0, 0, 0.85);\n  cursor: pointer;\n  margin-right: 12px;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n}\n\n.previewIcons {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.mapContainer {\n  position: relative;\n  height: 75vh;\n  width: 100%;\n}\n\n.legend {\n  position: absolute;\n  bottom: 30px;\n  left: 15px;\n  background: rgba(22, 19, 19, 0.8);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 20px;\n  box-sizing: border-box;\n  z-index: 1;\n  min-width: 200px;\n  border-radius: 5px;\n  padding: 10px 20px;\n\n  .timeRange {\n    color: #fff;\n    font-weight: 500;\n  }\n\n  .divider {\n    width: 100%;\n    height: 2px;\n    background: #fff;\n    margin: 10px 0;\n  }\n\n  .legendItem {\n    display: flex;\n    align-items: center;\n    margin: 5px 0;\n    color: #fff;\n    font-weight: 500;\n\n    .legendColor {\n      border: 2px solid #fff;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      margin-right: 10px;\n    }\n  }\n}\n\n.legendTextCheck {\n  color: #fff;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answerS3FileViewer": `MapPreview-module__answerS3FileViewer__eTXK6`,
	"answerS3FileViewerText": `MapPreview-module__answerS3FileViewerText__JaYIC`,
	"s3FactTableContainer": `MapPreview-module__s3FactTableContainer__C67lZ`,
	"s3FactTableButtonContainer": `MapPreview-module__s3FactTableButtonContainer__i47Gp`,
	"tableFactTableContainer": `MapPreview-module__tableFactTableContainer__vWczr`,
	"fileButton": `MapPreview-module__fileButton__xstUH`,
	"filePreviewContainer": `MapPreview-module__filePreviewContainer__JocNr`,
	"filePreviewHeader": `MapPreview-module__filePreviewHeader__OLSmn`,
	"expandContainer": `MapPreview-module__expandContainer__FJvAE`,
	"downloadButton": `MapPreview-module__downloadButton__ysNq4`,
	"title": `MapPreview-module__title__Srqxk`,
	"previewIcons": `MapPreview-module__previewIcons__g64OY`,
	"mapContainer": `MapPreview-module__mapContainer__ITd15`,
	"legend": `MapPreview-module__legend__nE_qW`,
	"timeRange": `MapPreview-module__timeRange__egyqT`,
	"divider": `MapPreview-module__divider__XvIYa`,
	"legendItem": `MapPreview-module__legendItem__WtxWv`,
	"legendColor": `MapPreview-module__legendColor__kuNHO`,
	"legendTextCheck": `MapPreview-module__legendTextCheck__OerQO`
};
export default ___CSS_LOADER_EXPORT___;
